export const isValidHexColor = (hex?: string | null) => {
  if (!hex) {
    return false;
  }

  const result = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return !!result;
};
